import { z } from 'zod';

import { ApiDataExportSchema } from '.';

export const DataExportHistorySchema = z.object({
  id: z.string(),
  createdAt: z.string(),
  payload: ApiDataExportSchema,
});

export type DataExportHistory = z.infer<typeof DataExportHistorySchema>;
